import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';

import { ButtonSplitGroup } from '@components/Buttons';
import { DidGroupsDetailsTable } from '@components/Capacity/DidGroups/Details';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page404, Page500 } from '@containers/ErrorPages';
import { didGroupsApi } from '@reducers/capacity';
import { skipToken } from '@reduxjs/toolkit/query';

export const Details = () => {
  const [defaultGroupDids, setDefaultGroupDids] = useState([]);
  const [detailsGroupDids, setDetailsGroupDids] = useState([]);

  const didsActions = {
    default: { dids: defaultGroupDids, setValue: setDefaultGroupDids },
    details: { dids: detailsGroupDids, setValue: setDetailsGroupDids },
  };

  const { id } = useParams();
  const didGroupDetails = didGroupsApi.useGetDetailsQuery({
    id,
  });

  const defaultDidGroupDetails = didGroupsApi.useGetDetailsQuery(
    !didGroupDetails.isLoading &&
      !didGroupDetails.isError &&
      didGroupDetails.data &&
      !didGroupDetails.data.is_default &&
      didGroupDetails.data.default_group_id
      ? {
          id: didGroupDetails.data.default_group_id,
        }
      : skipToken
  );

  const [updateTrigger] = didGroupsApi.useUpdateDidGroupMutation();

  useEffect(() => {
    if (!didGroupDetails.data) {
      return;
    }
    didsActions.details.setValue(didGroupDetails.data.dids);
  }, [didGroupDetails.data]);
  useEffect(() => {
    if (!defaultDidGroupDetails.data) {
      return;
    }
    didsActions.default.setValue(defaultDidGroupDetails.data.dids);
  }, [defaultDidGroupDetails.data]);
  if (didGroupDetails.isLoading || didGroupDetails.isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (didGroupDetails.isError) {
    return <Page500 />;
  }
  if (!didGroupDetails.data) {
    return <Page404 />;
  }
  if (defaultDidGroupDetails.isLoading || defaultDidGroupDetails.isFetching) {
    return <DefaultSpinnerCenter />;
  }

  if (defaultDidGroupDetails.isError) {
    return <Page500 />;
  }

  if (
    !didGroupDetails.data.is_default &&
    didGroupDetails.data.default_group_id &&
    !defaultDidGroupDetails.data
  ) {
    return <Page404 />;
  }
  const { is_default: isDefault } = didGroupDetails.data;

  const newForDefault = didsActions.default.dids.filter((item) =>
    defaultDidGroupDetails.data
      ? !defaultDidGroupDetails.data.dids.includes(item)
      : false
  );
  const newForDetails = didsActions.details.dids.filter((item) =>
    didGroupDetails.data ? !didGroupDetails.data.dids.includes(item) : false
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">
        {didGroupDetails.data.country}, {didGroupDetails.data.plan}, DID-Group -{' '}
        <span className="fw-bold">{didGroupDetails.data.name}</span>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <ButtonSplitGroup>
              <Button
                variant="didxl"
                size="sm"
                as={Link}
                to={`/capacity/did-groups/${id}/rename`}
              >
                Rename DID-Group
              </Button>
              <Button
                variant="didxl"
                size="sm"
                as={Link}
                to={`/capacity/did-groups/${id}/delete`}
              >
                Delete DID-Group
              </Button>
              <Button
                variant="didxl"
                size="sm"
                as={Link}
                to="/order/shared-channels"
              >
                Order Channels
              </Button>
            </ButtonSplitGroup>
          </Col>
        </Row>
        <Row className="mt-3">
          {isDefault ? (
            <Col md={4}>
              <DidGroupsDetailsTable
                name={didGroupDetails.data.name}
                dids={didsActions.details.dids}
                didsActions={didsActions}
              />
            </Col>
          ) : (
            <>
              <Col md={4}>
                <DidGroupsDetailsTable
                  name={
                    defaultDidGroupDetails.data
                      ? defaultDidGroupDetails.data.name
                      : ''
                  }
                  dids={didsActions.default.dids}
                  didsActions={didsActions}
                  withActions
                />
              </Col>
              <Col md={4}>
                <DidGroupsDetailsTable
                  name={didGroupDetails.data ? didGroupDetails.data.name : ''}
                  dids={didsActions.details.dids}
                  didsActions={didsActions}
                  withActions
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col>
            <ButtonSplitGroup>
              <Button
                variant="didxl"
                size="sm"
                onClick={() => {
                  [
                    {
                      id: didGroupDetails.data.default_group_id,
                      data: newForDefault,
                    },
                    {
                      id,
                      data: newForDetails,
                    },
                  ].forEach(({ id: groupID, data }) => {
                    if (data.length === 0) {
                      return;
                    }
                    updateTrigger({
                      id: groupID,
                      data: { dids: data.map(({ did }) => did) },
                    });
                  });
                }}
              >
                Save DID-Groups
              </Button>
              <Button
                variant="didxl-danger"
                size="sm"
                as={Link}
                to="/capacity/did-groups/existing"
              >
                Cancel
              </Button>
            </ButtonSplitGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            Please click a DID to move it to the other DID Group. If you want to
            move DID’s between Groups, you always have to move them to the
            Default DID-Group first.
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
